module.exports = __webpack_public_path__ + "img/48.a5d305a3.jpg";